import { render } from "./howToPlay.vue?vue&type=template&id=0942ae8c"
import script from "./howToPlay.vue?vue&type=script&lang=js"
export * from "./howToPlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__